/** @jsx jsx */
import React, { useState, Fragment, useEffect } from 'react';
import { jsx } from '@emotion/core'
import env from '../../../env';
import { SiteLink } from '../../../components'; //useRouter
//import { useHistory } from "react-router-dom";
import { useForm } from '../../../form';
import { fb, validators } from '../../../form';
import { Button, ErrorMessage } from '../../../components';
import { usePost } from '../../../components';
import utils from '../../../utils';
import style from './productViewStyle';
//import { MdKeyboardArrowDown } from "react-icons/md";
import { useStore } from '../../../store';
import { ProductPrice } from './price';
//import {ProductAttributes} from './productAttributes';

export function AddToCart({ product, variantOnly, openPopupImage, currency }) {
  
  const post = usePost();
  //const { Redirect } = useRouter();
  //const history = useHistory();
  const [checkGoToCartBtn, setCheckGoToCartBtn] = useState(false);
  
  // Initialize personalization state - always start with 'none' so user must actively choose
  const [personalisationOptionState, setPersonalisationOptionState] = useState('none');
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const { dispatch, state } = useStore();
  
  const render = (name, parent = null) => form.renderControl(name, parent);
  const model = getFormModel(product, {});
  const form = useForm(model, { usePlaceholder: true, onControlChanged: onControlChanged });

  const [attributesEx, setAttributesEx] = useState(() => {
    let _array = [];
    for(let n in product.variantAttributes){
      console.log(n, product.variantAttributes[n].options[0].value);
      _array.push(product.variantAttributes[n].options[0].value);
    }
    return _array;
  });

  function onControlChanged(e, control) {
    // Handle personalization option changes FIRST before variant handling
    if (control.name === 'personalisationOption') {
      const newValue = control.value || 'none';
      setPersonalisationOptionState(newValue); // Update state to trigger re-render
      
      // Clear personalization fields when switching to 'none'
      if (newValue === 'none') {
        const personalisationTextControl = form.findControl('personalisationText');
        const numberControl = form.findControl('number');
        if (personalisationTextControl) {
          personalisationTextControl.value = '';
          personalisationTextControl.errors = [];
        }
        if (numberControl) {
          numberControl.value = '';
          numberControl.errors = [];
        }
      }
      return; // Important: return after handling personalization
    }
    
    // Handle variant option changes
    if (control.type === 'select' && control.parent){
      const newModel = getFormModel(product, form.getValue())
      form.reset(newModel)
      return;
    }
  }

  function addToCart(e) {
    form.validateForm(e, () => {
      const formVal = form.getValue();
      
      // Validate personalization fields if personalization is selected
      if (formVal.personalisationOption && formVal.personalisationOption !== 'none') {
        if (formVal.personalisationOption === 'name' && !formVal.personalisationText?.trim()) {
          const personalisationTextControl = form.findControl('personalisationText');
          if (personalisationTextControl) {
            personalisationTextControl.errors = ['Name is required'];
            personalisationTextControl.touched = true;
          }
          return;
        }
        if (formVal.personalisationOption === 'number' && !formVal.number?.trim()) {
          const numberControl = form.findControl('number');
          if (numberControl) {
            numberControl.errors = ['Number is required'];
            numberControl.touched = true;
          }
          return;
        }
        if (formVal.personalisationOption === 'name_and_number') {
          let hasError = false;
          if (!formVal.personalisationText?.trim()) {
            const personalisationTextControl = form.findControl('personalisationText');
            if (personalisationTextControl) {
              personalisationTextControl.errors = ['Name is required'];
              personalisationTextControl.touched = true;
              hasError = true;
            }
          }
          if (!formVal.number?.trim()) {
            const numberControl = form.findControl('number');
            if (numberControl) {
              numberControl.errors = ['Number is required'];
              numberControl.touched = true;
              hasError = true;
            }
          }
          if (hasError) return;
        }
      }
      
      let _variantOptions = [];
      for(let i in formVal.variantOptions){
        let _item = {
          name : formVal.variantOptions[i].name,
          value : formVal.variantOptions[i][Object.keys(formVal.variantOptions[i])[1]]
        };
        _variantOptions.push(_item);
      }
      
      // Add personalisation as a variant option if selected
      if (formVal.personalisationOption && formVal.personalisationOption !== 'none') {
        let personalisationValue = '';
        
        // Build the personalization value string based on selected option
        if (formVal.personalisationOption === 'name' && formVal.personalisationText) {
          personalisationValue = 'Name: ' + formVal.personalisationText;
        } else if (formVal.personalisationOption === 'number' && formVal.number) {
          personalisationValue = 'Number: ' + formVal.number;
        } else if (formVal.personalisationOption === 'name_and_number') {
          const parts = [];
          if (formVal.personalisationText) parts.push('Name: ' + formVal.personalisationText);
          if (formVal.number) parts.push('Number: ' + formVal.number);
          if (parts.length > 0) {
            personalisationValue = parts.join(', ');
          }
        }
        
        _variantOptions.push({
          name: 'Personalisation',
          value: personalisationValue
        });
      }
      
      //const value = { ...formVal, productId: product.productId, cartId: env.getDevCartId() };
      let _cartId = env.getDevCartId();
      const value = { 
        quantity : formVal.quantity,
        variantOptions : _variantOptions,
        productId: product.productId,
        cartId: _cartId === 'null' ? null : _cartId
      };
      
      setCheckGoToCartBtn(false);
      setSendingStatus('pending');
      post.send(env.apiBase + "/api/cart/addtocartforclubmanger", value);

    })
  }

  // Handle API response in useEffect to avoid infinite re-renders
  useEffect(() => {
    if (post.done() && checkGoToCartBtn === false) {
      env.setDevCartId(post.response.results.cartInfo.cartId);
      setSendingStatus(null);
      if(post.response.errors.length < 1){
        setTimeout(() => {
          dispatch({type:'SET_STATE', payload : {cartInfo : post.response.results.cartInfo.totalQuantity || 0}});
          setCheckGoToCartBtn(true);
        }, 500); 
      }
    }

    if(post.hasErrors()){
      setSendingStatus(null);
      if(post.errors[0].includes("There are non-compatible products")){
        setTimeout(() => {
          setCheckGoToCartBtn(true);    
        }, 500);
      }
    }
  }, [post, checkGoToCartBtn, dispatch]);

  const attributes = form.findControl('variantOptions');
  

  return <div style={{ marginBottom: '1.5rem' }}>
    {/* <div className="productView__price">
      Price: <b>{product.priceText ? product.priceText : 'AU ' + utils.money.formatMoney(product.price)}</b>
    </div> */}

    {/* <ProductAttributes product={product} /> */}

    {
      product.productStatus !== 100 &&

      <Fragment>
        {attributes.controls.length > 0 && <hr/> }

{
 attributes.controls.map(
   (item, index) =>
   { 
     return(
       <div className="row" key={index} css={style.newOptionRow}>
         
         <div className="col-12" style={{fontWeight: 600}}>
           {item.controls[0].value}
         </div>

         <div className="col-12">
           <div css={style.newOptionStyleContainer}>
             {
               item.controls[1].options.map((sitem, sindex) => 
               <div key={sindex} css={style.newOptionStyleItem} className={`${item.controls[1].value === sitem.value ? "selected" : ""}`} onClick={()=>{
                 item.controls[1].value = sitem.value;
                 setAttributesEx(pre => {
                   let _new = {...pre};
                   return _new;
                 });
               }}>
                 {sitem.name}
               </div>)
             }
           </div>
         </div>
         {/* <div className="col-md-12">{render('value', item)}</div> */}
       </div>
     )
   }
 )
}

      </Fragment>

    }
  
    {
      (product.chartImage && product.chartImage !== "") &&
      <div css={style.sizeChartBtn} onClick={() => {
        openPopupImage();
      }}> 
        View Size Chart
      </div>
    }

    {(() => {
      if (!product.ext || !product.ext.personalisationOption || product.ext.personalisationOption === 'none') {
        return null;
      }
      
      return (
        <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          {/* <hr />
          <div className="row">
            <div className="col-md-12">
              <h5>Personalisation Options</h5>
              {product.ext.personalisationPrice && (
                <p style={{ fontSize: '0.9rem', color: '#666' }}>
                  Additional charge: AU ${utils.money.formatMoney(product.ext.personalisationPrice)}
                </p>
              )}
            </div>
            <div className="col-12" style={{ marginBottom: '1rem' }}>
              {render('personalisationOption')}
            </div>
          </div> */}
          
          {/* Show personalization input fields based on selected option */}
          {personalisationOptionState !== 'none' && (() => {
            // Normalize old values for backward compatibility
            const selectedOption = personalisationOptionState === 'name_only' ? 'name' : 
                                  personalisationOptionState === 'number_only' ? 'number' : 
                                  personalisationOptionState;
            
            return (
              <div className="row" style={{ marginTop: '0.5rem' }}>
                {/* Name & Number (show both) */}
                {selectedOption === 'name_and_number' && (
                  <>
                    <div className="col-md-6">
                      {render('personalisationText')}
                    </div>
                    <div className="col-md-6">
                      {render('number')}
                    </div>
                  </>
                )}
                
                {/* Name only */}
                {selectedOption === 'name' && (
                  <div className="col-12">
                    {render('personalisationText')}
                  </div>
                )}
                
                {/* Number only */}
                {selectedOption === 'number' && (
                  <div className="col-12">
                    {render('number')}
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      );
    })()}

  {!variantOnly &&<form onSubmit={addToCart} style={{ textAlign: 'left', marginBottom: '2rem' }}>
      {/* <div className="form-row" style={{marginTop:'1rem', marginBottom: '0.5rem'}}>
        <div className="col-md-8" css={style.priceText}>
          All prices shown in AUD
        </div>
        <div className="col-md-4">
          <div className="productView__price">
            <b>{product.priceTextOveriding ? product.priceTextOveriding : 'AU ' + utils.money.formatMoney(product.priceIncTax)}</b>
          </div>
        </div>
      </div> */}
      <ProductPrice product={product} currency = {state.currency} />

      <div className="form-row">
          <div className="qty col-md-4">
            {render('quantity')}
          </div>
          <div className="col-md-8" css={style.addToCartBtn}>
            <Button onClick={addToCart} status={post.status} className={`${sendingStatus === 'pending' ? 'pending' : ''}`}> ADD TO CART </Button>
          </div>
          <div className = "col-md-12">
            <ErrorMessage errors={post.errors} />
          </div>
          <div className="col-md-8 offset-md-4">
            {
              checkGoToCartBtn === true &&
              <SiteLink className = "btn-primary btn" to = "/member/cart" style = {{marginTop: '0.5rem'}}> GO TO CART </SiteLink>
            }
          </div>
        </div>
        
        <div>
          {/* <Button onClick={addToCart} status={form.status}>Add to cart</Button> */}
          <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." /> 
        </div>
    </form>}
  </div>
}

// Helper function to get personalization options based on product setting
function getPersonalisationOptions(personalisationOption) {
  const options = [
    { name: 'No Personalisation', value: 'none' }
  ];
  
  // Normalize old values for backward compatibility
  // Old admin form used 'name_only' and 'number_only', new form uses 'name' and 'number'
  const normalizedOption = personalisationOption === 'name_only' ? 'name' : 
                          personalisationOption === 'number_only' ? 'number' : 
                          personalisationOption;
  
  // Add the specific personalization option(s) available for this product
  if (normalizedOption === 'number') {
    options.push({ name: 'Number Only', value: 'number' });
  } else if (normalizedOption === 'name') {
    options.push({ name: 'Name Only', value: 'name' });
  } else if (normalizedOption === 'name_and_number') {
    options.push({ name: 'Name & Number', value: 'name_and_number' });
  }
  
  return options;
}

function getFormModel(product, formValues /* for reset */) {
  const variantAttributes = product.variantAttributes;
  const personalisationOption = product.ext && product.ext.personalisationOption ? product.ext.personalisationOption : 'none';
  const hasPersonalisation = personalisationOption !== 'none';

  const model = fb.group({
    //quantity: [formValues.quantity || 1, [validators.Required()], { label: 'Quantity', type: 'number' }],
    quantity: [formValues.quantity || 1, [validators.Required()], { label: 'Quantity', type: 'number' }],
    variantOptions: fb.array([]),
    personalisationOption: hasPersonalisation ? [formValues.personalisationOption || 'none', [], { 
      label: 'Personalisation', 
      type: 'select', 
      options: getPersonalisationOptions(personalisationOption)
    }] : ['none', [], { type: 'hidden' }],
    personalisationText: [formValues.personalisationText || '', [], { 
      label: 'Name', 
      type: 'text',
      placeholder: 'Enter name',
      maxlength: 100
    }],
    number: [formValues.number || '', [], { 
      label: 'Number', 
      type: 'text',
      placeholder: 'Enter number',
      maxlength: 50
    }],
  });
  const variantOptionArray = model.find('variantOptions').controls;
  (variantAttributes || []).forEach(attr => {
    variantOptionArray.push(newVariantAttribute(attr, formValues, product.variants))
  })
  return model;
}

// function newVariantAttribute(attr, formValues, variants) {
//   //console.log(attr, formValues, variants)
//   const optionsSelected = formValues.variantOptions || [];
//   const currentSelection = utils.array.find(optionsSelected, x => attr.name === x.name);
//   const filtered = variants
//     .filter(x => matchVariantOptions(optionsSelected, x.variantOptions, attr.name))
//   const availableOptions = getAvailableOptionValues(filtered, attr.name);
//   const options = attr.options.map(x => { return { ...x, ...{ disabled: !availableOptions.some(o => o === x.value) } } })
//   return fb.group({
//     name: [attr.name, [], { type: 'hidden' }],
//     value: [(currentSelection && currentSelection.value) || attr.value || '',
//     [validators.Required()], {
//       //label: attr.name,
//       label: null,
//       type: 'select',
//       options: [{ displayName: 'Select ...', value: '' }, ...options].map(x => {
//         return {
//           name: (x.displayName || x.value) + (x.disabled || false ? ' - not available' : ''),
//           value: x.value,
//           disabled: x.disabled || false
//         }
//       })
//     }]
//   })
// }

function newVariantAttribute(attr, formValues, variants) {
  
  // const choices = [
  //   { name: 'Yes, please!', value: 'Yes' },
  //   { name: 'No, thanks', value: 'No' }
  // ]

  const dyName =  attr.name.toLowerCase();
  const optionsSelected = formValues.variantOptions || [];
  const currentSelection = utils.array.find(optionsSelected, x => attr.name === x.name);

  const filtered = variants
    .filter(x => matchVariantOptions(optionsSelected, x.variantOptions, attr.name))
  const availableOptions = getAvailableOptionValues(filtered, attr.name);
  const options = attr.options.map(x => { return { ...x, ...{ disabled: !availableOptions.some(o => o === x.value) } } });

  return fb.group({
    name: [attr.name, [], { type: 'hidden' }],
    [dyName] : [(currentSelection && currentSelection.value) || attr.value || options[0].value,
    [validators.Required()], {
      //label: attr.name,
      label: null,
      type: 'radioList',
      //options : choices
      options: [...options].map(x => {
        return {
          name: (x.displayName || x.value) + (x.disabled || false ? ' - not available' : ''),
          value: x.value,
          disabled: x.disabled || false
        }
      })
    }]
  })
}

function getAvailableOptionValues(variants, name) {
  const values = variants.map(x => {
    const options = x.variantOptions.filter(o => o.name === name)
    return options && options[0].value
  }).filter(x => x);

  return Array.from(new Set(values));
}

function matchVariantOptions(optionsSelected, optionsInVariant, currentControlName) {
  //console.log(optionsSelected, optionsInVariant, currentControlName)
  for (let i = 0; i < optionsSelected.length; i++) {
    let optionSelected = optionsSelected[i];
    if (optionSelected.value === '') {
      // skip match test
      continue;
    }
    if (optionSelected.name === currentControlName) {
      // skip match test for the just selected value
      continue;
    }
    let found = false;
    for (let j = 0; j < optionsInVariant.length; j++) {
      let optionInVariant = optionsInVariant[j];
      if (optionSelected.name === optionInVariant.name && optionSelected.value === optionInVariant.value) {
        found = true;
        break;
      }
    }
    if (!found) return false;
  }
  return true;
}